var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { ToolbarWithBackButton } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment, GridHeader, TileHeaderAddButtonWithRouter, } from '../common/Tile';
import Loading from '../common/Loading';
import { EntityHeader } from '../common/EntityHeader';
import View from '../common/View';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { AlertDialog } from '../common/alert-dialog';
import { useRemoveEmailMutation, useViewerQuery, UserRole, } from '../../__generated__/graphql';
var content = [
    {
        label: 'Login and security',
        items: [
            // { label: 'E-mail', comment: 'E-mail addresses' },
            { label: 'Password', comment: 'Change your password' },
            { label: 'Two Factor Authentication', comment: 'E-mail addresses' },
        ],
    },
    {
        label: 'Connected accounts',
        items: [
            { label: 'LinkedIn', comment: '' },
            { label: 'AngelList', comment: '' },
            { label: 'Facebook', comment: '' },
            { label: 'Google', comment: '' },
            { label: 'GitHub', comment: '' },
            { label: 'Bitbucket', comment: '' },
            { label: 'Twitter', comment: '' },
            { label: 'Atlassian', comment: '' },
            { label: 'Asana', comment: '' },
            { label: 'Sharepoint', comment: '' },
            { label: 'Dropbox', comment: '' },
            { label: 'Box', comment: '' },
        ],
    },
];
export default function AccountHome() {
    var _this = this;
    var _a = useViewerQuery(), data = _a.data, loading = _a.loading;
    var viewer = data && data.viewer;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(null), selectedEmail = _c[0], setSelectedEmail = _c[1];
    var removeEmail = useRemoveEmailMutation({
        variables: { email: selectedEmail || '' },
    })[0];
    var emailClick = function (address) { return function () {
        setIsOpen(true);
        setSelectedEmail(address);
    }; };
    var removeEmailClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = removeEmail();
                    setIsOpen(false);
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var cancelClick = function () {
        setIsOpen(false);
    };
    if (loading) {
        return _jsx(Loading, {}, void 0);
    }
    if (!viewer) {
        throw new Error('Viewer not found');
    }
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog, { "data-test": "remove-email-dialog", isOpen: isOpen, title: "Remove email", content: selectedEmail || '', onBackdropClick: cancelClick, buttons: [
                    {
                        label: 'Remove',
                        primary: true,
                        onClick: removeEmailClick,
                    },
                    {
                        label: 'Cancel',
                        onClick: cancelClick,
                    },
                ] }, void 0),
            _jsx(ToolbarWithBackButton, { children: "My Account" }, void 0),
            _jsxs(Body, { children: [_jsx(EntityHeader, { label: viewer.name, comment: "", icon: "account" }, void 0),
                    _jsx(GridHeader, { children: 'Login and security' }, void 0),
                    _jsx(Grid, { children: _jsxs(Tile, { children: [_jsxs(TileHeader, { children: ['Emails', _jsx(TileHeaderAddButtonWithRouter, { to: "/account/add-email", "data-test": "add-email-button" }, void 0)] }, void 0),
                                _jsx(List, { children: viewer.emails.map(function (_a, i) {
                                        var address = _a.address;
                                        return (_jsx(ListItem, { primary: address, onClick: emailClick(address) }, i));
                                    }) }, void 0)] }, void 0) }, void 0),
                    _jsx(View, __assign({ allowedRoles: [UserRole.DEVELOPER] }, { children: content.map(function (e, i) { return (_jsxs(Fragment, { children: [_jsx(GridHeader, { children: e.label }, void 0),
                                _jsx(Grid, { children: e.items.map(function (item, j) { return (_jsxs(Tile, { children: [_jsx(TileHeader, { children: item.label }, void 0),
                                            _jsx(TileComment, { children: item.comment }, void 0)] }, j)); }) }, void 0)] }, i)); }) }), void 0)] }, void 0)] }, void 0));
}
//# sourceMappingURL=AccountHome.js.map